<template>
  <footer class="footer-section" :class="[hidden, hiddenXS, hiddenSM]">
    <div class="row ">
      <div class="col-6">
        <div class="form-group d-block d-sm-none">
          <label>{{ $t('message.footer.language') }}</label>
          <div class="select-jumbo">
            <select v-model="currentLanguage" @change="$parent.setLocaleLanguage(currentLanguage)">
              <option value="en">English</option>
              <option value="th">ภาษาไทย</option>
            </select>
          </div>
        </div>
        <div class="col-6">&nbsp;</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 mb-4">
        <h4>{{ $t('message.footer.customer') }}</h4>
        <ul class="list-unstyled footer-list">
          <li>
            <router-link to="/booking/start">{{ $t('message.menu.book_cleaner') }}</router-link>
          </li>
          <li>
            <router-link to="/promotions">{{ $t('message.menu.promotions') }}</router-link>
          </li>
          <li>
            <router-link to="/pricing">{{ $t('message.menu.pricing') }}</router-link>
          </li>
          <li>
            <router-link to="/service">{{ $t('message.footer.our_service') }}</router-link>
          </li>
          <li>
            <router-link to="/term">{{ $t('message.footer.terms_of_use') }}</router-link>
          </li>
          <li>
            <router-link to="/term-and-conditions">{{ $t('message.footer.terms_and_conditions') }}</router-link>
          </li>
          <li>
            <router-link to="/privacy">{{ $t('message.footer.privacy_policy') }}</router-link>
          </li>
          <li>
            <router-link to="/safety">{{ $t('message.footer.safety') }}</router-link>
          </li>
          <li>
            <div class="mt-3 d-flex">
              <a href="https://www.facebook.com/beneatco" target="_blank">
                <img src="/static/img/ic-facebook.svg" alt="" width="36">
              </a>
              &nbsp;
              <a href="https://www.instagram.com/beneat.co/?hl=th" target="_blank">
                <img src="/static/img/ic-instagram.svg" alt="" width="36">
              </a>
              &nbsp;
              <a href="https://twitter.com/BeNeatCo" target="_blank">
                <img src="/static/img/ic-twitter.svg" alt="" width="36">
              </a>
              &nbsp;
              <a href="https://www.tiktok.com/@beneat.official" target="_blank">
                <img src="/static/img/ic-tiktok.png" alt="" width="37">
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-2 mb-4">
        <h4>{{ $t('message.footer.professional') }}</h4>
        <ul class="list-unstyled footer-list">
          <li>
            <router-link to="/apply">{{ $t('message.footer.be_a_professional') }}</router-link>
          </li>
          <!--          <li>
                      <router-link to="/declining-booking">{{ $t('message.footer.declining_booking') }}</router-link>
                    </li>-->
        </ul>

        <div>
          <h4>{{ $t('message.footer.download_apps') }}</h4>
          <ul class="list-unstyled footer-list mt-3">
            <li>
              <a href="https://itunes.apple.com/th/app/beneat/id1203611695?mt=8" target="_blank">
                <img height="38" alt="Line BeNeat" src="/static/img/btn-app-store.svg">
              </a>
            </li>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.beneat.app" target="_blank">
                <img height="38" alt="Line BeNeat" src="/static/img/btn-play-store.svg">
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-md-2">
        <h4>{{ $t('message.footer.contact_us') }}</h4>
        <ul class="list-unstyled footer-list">
          <li>
            <i class="fas fa-map-marker-alt"></i>&nbsp;
            <span v-html="$t('message.footer.address.01')"></span>
          </li>
          <li class="mt-4">
            <i class="fas fa-map-marker-alt"></i>&nbsp;
            <span v-html="$t('message.footer.address.02')"></span>
          </li>
          <!-- <li class="mt-4">
            <i class="fas fa-map-marker-alt"></i>&nbsp;
            <span v-html="$t('message.footer.address.05')"></span>
          </li> -->
        </ul>
      </div>

      <div class="col-md-2">
        <h4>&nbsp;</h4>
        <ul class="list-unstyled footer-list">
          <li>
            <i class="fas fa-map-marker-alt"></i>&nbsp;
            <span v-html="$t('message.footer.address.03')"></span>
          </li>
          <li class="mt-4">
            <i class="fas fa-map-marker-alt"></i>&nbsp;
            <span v-html="$t('message.footer.address.04')"></span>
          </li>
          <li>
            <i class="fas fa-map-marker-alt"></i>&nbsp;
            <span v-html="$t('message.footer.address.06')"></span>
          </li>
        </ul>
      </div>

      <div class="col-md-2">
        <h4>&nbsp;</h4>
        <ul class="list-unstyled footer-list">
          <li>
            <i class="fas fa-map-marker-alt"></i>&nbsp;
            <span v-html="$t('message.footer.address.07')"></span>
          </li>
        </ul>
      </div>

      <div class="col-md-2">
        <h4>&nbsp;</h4>
        <ul class="list-unstyled footer-list">
          <li><i class="fas fa-phone"></i>&nbsp;&nbsp;<a href="tel:+6621131138" class="text-light">02-113-1138</a>,
            <a href="tel:+66927572999" class="text-light">092-757-2999</a></li>
          <li><i class="fas fa-envelope"></i>&nbsp;&nbsp;<a href="mailto:info@beneat.co" class="text-light">info@beneat.co</a></li>
          <li>&nbsp;</li>
          <li>
            <!-- <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
              <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
            </a> -->
            <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
              <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
            </a>
          </li>
          <li>
            <a href="https://www.messenger.com/t/beneatco/" target="_blank">
              <img height="38" alt="FB Messenger BeNeat" src="/static/img/btn-fb-messenger.png">
            </a>
          </li>
          <li>
            <h4>มาตรฐานที่ได้รับ</h4>
          </li>
          <li>
            <img class="responsive-img-standard" src="/static/img/loco-issa-cleaning-management-institute.png" alt="issa cleaning management institute">
          </li>
          <li>
            <img class="responsive-img-standard" src="/static/img/Logo-DTC-LCB.png" alt="DTC LCB">
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        Copyright © 2025 by BeNeat Co.,Ltd. All right reserved.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      currentLanguage: this.$i18n.locale,
      noFooterPaths: ['/booking', '/promotion', '/promotion-review', '/confirm-declined-booking',
        '/professional-income/:id', '/professional-bonus/:id', '/professional-debt/:id',
        '/cleaner/:id/card', '/subscription-detail', '/recent-reviews',
        '/twitter-campaign', '/facebook-post', '/user/:id/calendar', '/chat-booking', '/article/category', '/article/category/:name',
        '/line-provider/login', '/line-professional/login', '/line-professional/callback', '/invite-friends', '/finnix',
        '/professional/:id/examination', '/professional-questionnaire/:id/test', '/pre-qr-payments', '/job-posts', '/job-posts/:id', '/services/:id',
        '/partners/:id/report', '/professional-login', '/professional-dashboard', '/partners', '/partners/:id/orders/:orderId', '/q-chang', '/inconvenience-maintenance',
        '/partners', '/partners/:id/orders/:orderId', '/q-chang', '/cleaner/:id/contracts/1', '/cleaner/:id/contracts/2',
        '/big-cleaning', '/agency-professional-register', '/user/shipping-address', '/survey-ironing', '/survey-bathroom-cleaning', '/cleaner/:id/consents/1', '/cleaner/consents/1', '/cleaner/:id/consents/2', '/survey/1',
        '/feedback/operation', '/recruitment', '/mikuagency', '/million-booking-celebrate', '/lineman-promotion', '/admin/:id/test/:testId'
      ],
      noFooterSmPaths: ['/cleaner/:id', '/special-services/:id']
    }
  },
  computed: {
    hidden () {
      return {
        'd-none': (this.noFooterPaths.indexOf(this.$route.matched[0].path) > -1)
      }
    },
    hiddenSM () {
      return {
        'd-sm-none d-md-block': (this.noFooterSmPaths.indexOf(this.$route.matched[0].path) > -1)
      }
    },
    hiddenXS () {
      return {
        'd-none d-sm-block': (this.noFooterSmPaths.indexOf(this.$route.matched[0].path) > -1)
      }
    }
  }
}
</script>

<style>
.select-jumbo {
  color: black;
}
.responsive-img-standard {
  width: 100%;
}
@media only screen and (max-width: 600px) {
  .responsive-img-standard {
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue